/* Pet's Best Life — vet opt-in form. Config comes from the section settings via data-* attributes. */
(function(){
  if(window.__pblVetInit)return; window.__pblVetInit=1;
  var EMAIL=/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function mark(input,ok){
    var f=input.closest('.pbv-field'); if(!f)return ok;
    if(ok){f.removeAttribute('data-invalid');input.removeAttribute('aria-invalid');}
    else{f.setAttribute('data-invalid','');input.setAttribute('aria-invalid','true');}
    return ok;
  }
  function init(){
    // Shopify customer form: fold the chosen role into contact[tags]
    document.querySelectorAll('[data-pbv-shopify-wrap] form').forEach(function(form){
      var role=form.querySelector('[data-pbv-role]'),tags=form.querySelector('[data-pbv-tags]');
      if(role&&tags)role.addEventListener('change',function(){
        tags.value=(tags.getAttribute('data-base')||'')+', role: '+role.value;
        mark(role,true);
      });
      form.addEventListener('submit',function(ev){
        var email=form.querySelector('input[type=email]');
        var okE=email?mark(email,EMAIL.test(email.value.trim())):true;
        var okR=role?mark(role,!!role.value):true;
        if(!okE||!okR){ev.preventDefault();(okE?role:email).focus();}
      });
    });

    // Klaviyo form: post straight to the public subscribe API
    document.querySelectorAll('form[data-pbv-form]').forEach(function(form){
      var btn=form.querySelector('.pbv-btn'),err=form.querySelector('[data-pbv-formerr]');
      var company=form.getAttribute('data-company'),list=form.getAttribute('data-list'),source=form.getAttribute('data-source')||'Vet opt-in page';
      var box=form.parentNode.querySelector('[data-pbv-success]');
      var label=btn?btn.querySelector('.pbv-btn__t'):null,labelText=label?label.textContent:'';
      function done(){
        var n=form.first_name?form.first_name.value.trim():'';
        var slot=box?box.querySelector('[data-pbv-name]'):null; if(slot)slot.textContent=n?', '+n:'';
        form.hidden=true; if(box){box.hidden=false;box.focus();}
      }
      form.addEventListener('submit',function(ev){
        ev.preventDefault(); if(err)err.hidden=true;
        var okE=mark(form.email,EMAIL.test(form.email.value.trim()));
        var okR=mark(form.vet_role,!!form.vet_role.value);
        if(!okE){form.email.focus();return;} if(!okR){form.vet_role.focus();return;}
        if(!list){console.warn('[pbl-vet] No Klaviyo list ID set on the section: preview mode, nothing sent.');done();return;}
        if(btn){btn.disabled=true;if(label)label.textContent='Joining…';}
        var practice=form.practice_name?form.practice_name.value.trim():'';
        var body={data:{type:'subscription',attributes:{custom_source:source,profile:{data:{type:'profile',attributes:{
          email:form.email.value.trim(),
          first_name:form.first_name&&form.first_name.value.trim()||undefined,
          organization:practice||undefined,
          properties:{vet_role:form.vet_role.value,practice_name:practice||undefined,signup_source:source}
        }}}},relationships:{list:{data:{type:'list',id:list}}}}};
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+company,{method:'POST',headers:{'Content-Type':'application/vnd.api+json',revision:'2024-10-15'},body:JSON.stringify(body)})
          .then(function(r){if(!r.ok)throw new Error(r.status);done();})
          .catch(function(){if(err)err.hidden=false;if(btn){btn.disabled=false;if(label)label.textContent=labelText;}});
      });
      if(form.email)form.email.addEventListener('blur',function(){if(this.value)mark(this,EMAIL.test(this.value.trim()));});
      if(form.vet_role)form.vet_role.addEventListener('change',function(){mark(this,true);});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
